module.exports = __webpack_public_path__ + "img/judge-2.d2f5adc2.png";